import {
  CancelReason,
  ManageRmsOrderRequest,
  ManageRmsOrderResponse,
  Order,
  OrdersResponse,
  RmsOrderActionsResponse,
  RmsOrderStatusChangeRequest,
  OrderActionODMItem,
  OrderLoads,
  OrderExpand,
} from '@cemex-core/cmx-api';

import { Action } from '@ngrx/store';
import { OrdersOrderBy } from '../models/order-sortby.enum';
import { OrdersRequest } from '@ordersnproducts/modules/orders-and-product-catalog/modules/orders/models/orders-request.interface';
import { OrderDetailQueryParams } from '@ordersnproducts/modules/orders-and-product-catalog/modules/order-detail/constants/order-detail-query-params';
import { PatchOrderCancelRequest } from '@cemex-core/cmx-api/models/order-management/order-cancel-request';
import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';
import { OdmExpand } from '@ordersnproducts/modules/shared/models/odm-expand.interface';

export enum OrdersActionTypes {
  LOAD = '[Orders] Load orders list',
  LOAD_SUCCESS = '[Orders] Loaded orders list',
  LOAD_FAIL = '[Orders] Failed loading orders list',
  SET_LIMIT = '[Orders] Set limit',
  SET_CURRENT_PAGE = '[Orders] Set current page',
  SET_DATE_TIME_INTERVAL = '[Orders] Set date time interval',
  SET_ORDER_BY = '[Orders] Set order by parameter',
  RESET = '[Orders] Reset',
  SELECTED_ORDER_ONHOLD = '[Orders] Selected order on hold',
  SUBMIT_ORDER_ONHOLD = '[Orders] Requested order on hold',
  RESPONSE_ORDER_ONHOLD = '[Orders] Response order on hold',
  SELECTED_RESUME_ORDER = '[Orders] Selected resume order',
  FETCH_ORDER_MENU_ACTIONS = '[Orders] Gets the actions available for the selected order',
  FETCH_ORDER_MENU_ACTIONS_MANAGEMENT = '[Orders] Gets the actions available for the selected order (from ODM API).',
  CLEAR_ORDER_MENU_ACTIONS_MANAGEMENT = '[Orders] Clear the actions for the selected order (from ODM API).',
  SET_ORDER_MENU_ACTIONS = '[Orders] Sets the actions available for the selected order',
  SET_ORDER_MENU_ACTIONS_MANAGEMENT = '[Orders] Sets the actions available for the selected order (from ODM API).',
  SELECTED_ORDER_TO_CANCEL = '[Orders] Selected order to cancel',
  RESET_ORDER_TO_CANCEL = '[Orders] Reset order to cancel',
  SUBMIT_ORDER_TO_CANCEL = '[Orders] Submit order to cancel',
  SUBMIT_ORDER_CANCEL_ODM = '[Orders] Submit order cancel im/v3',
  VALIDATE_ORDER_TO_CANCEL = '[Orders] Validate order for cancellation',
  RESPONSE_ORDER_TO_CANCEL = '[Orders] Response order to cancel',
  RESPONSE_ORDER_TO_CANCEL_ODM = '[Orders] Response order to cancel ODM',
  RESPONSE_VALIDATE_ORDER_TO_CANCEL = '[Orders] Response validate order to cancel',
  FETCH_CANCEL_OPTIONS = '[Orders] Request options enlisted in cancel',
  SET_CANCEL_OPTIONS = '[Orders] Response options enlisted in cancel',
  EXPAND_ORDER = '[Orders] Expand order',
  EXPAND_ORDER_SUCCESSFULLY = '[Orders] Expand order succesfully',
  EXPAND_ODM_ORDER_SUCCESSFULLY = '[Orders] Expand odm order succesfully',
  LOAD_ORDERID = '[Orders] Load ordersId',
  LOAD__ORDERID_SUCCESS = '[Orders] Loaded orderId',
  FETCH_ONLINE_CANCEL_OPTIONS = '[Orders] Request options enlisted in online cancel',
  FETCH_CANCELLATION_REASONS = '[Orders] Request options enlisted in cancel im/v3',
  FETCH_MODIFICATION_REASONS = '[Orders] Request options enlisted in modify reason v3/im',
  SET_ACTION_EXPERIENCE = '[Orders] Sets selected action experience',
  RELOAD_ORDER_LIST = '[Orders] Reload orders list',
  FETCH_ORDER_LOADS = '[Orders] Fetch order loads',
  FETCH_ORDER_LOADS_COMPLETED = '[Orders] Fetch order loads completed',
  BUSINESS_LINE_CODE = '[Orders] set businessLineCode for rollout',
  SUBMIT_ORDER_TO_HOLD_ONLINE = '[Orders] Submit order to hold online',
  RESPONSE_ORDER_TO_HOLD_ONLINE = '[Orders] Response order to hold online',
  LOAD_JOBSITE_EXPERIENCE = '[Orders] Load jobsite experience',
  LOAD_JOBSITE_EXPERIENCE_SUCCESS = '[Orders] Loaded jobsite experience',
  LOAD_JOBSITE_EXPERIENCE_FAIL = '[Orders] Failed loading jobsite experience',
}

export class OrdersLoad implements Action {
  readonly type = OrdersActionTypes.LOAD;

  constructor(public payload: OrdersRequest) {}
}

export class OrdersLoadSuccess implements Action {
  readonly type = OrdersActionTypes.LOAD_SUCCESS;

  constructor(public payload: OrdersResponse) {}
}

export class OrdersLoadFail implements Action {
  readonly type = OrdersActionTypes.LOAD_FAIL;

  constructor(public payload: { error: Error }) {}
}

export class OrdersSetLimit implements Action {
  readonly type = OrdersActionTypes.SET_LIMIT;

  constructor(public payload: number) {}
}

export class OrdersSetCurrentPage implements Action {
  readonly type = OrdersActionTypes.SET_CURRENT_PAGE;

  constructor(public payload: number) {}
}

export class OrdersSetDateTimeInterval implements Action {
  readonly type = OrdersActionTypes.SET_DATE_TIME_INTERVAL;

  constructor(public payload: { dateTimeFrom: string; dateTimeTo: string }) {}
}

export class OrdersSetOrderBy implements Action {
  readonly type = OrdersActionTypes.SET_ORDER_BY;

  constructor(public payload: OrdersOrderBy) {}
}

export class OrdersReset implements Action {
  readonly type = OrdersActionTypes.RESET;

  constructor() {}
}

export class RequestOrderOnHold {
  readonly type = OrdersActionTypes.SUBMIT_ORDER_ONHOLD;
  constructor(public payload: ManageRmsOrderRequest) {}
}

export class ResponseOrderOnHold {
  readonly type = OrdersActionTypes.RESPONSE_ORDER_ONHOLD;
  constructor(public payload: ManageRmsOrderResponse) {}
}

export class SubmitOrderToHoldOnline {
  readonly type = OrdersActionTypes.SUBMIT_ORDER_TO_HOLD_ONLINE;
  constructor(
    public order: Order,
    public holdOnlinePayload: any,
  ) {}
}

export class ResponseOrderToHoldOnline {
  readonly type = OrdersActionTypes.RESPONSE_ORDER_TO_HOLD_ONLINE;
  constructor(public payload: any) {}
}

export class SelectOrderOnHold {
  readonly type = OrdersActionTypes.SELECTED_ORDER_ONHOLD;
  constructor(public payload: Order) {}
}

export class SelectResumeOrder {
  readonly type = OrdersActionTypes.SELECTED_RESUME_ORDER;
  constructor(public payload: Order) {}
}

export class FetchActionsForOrder {
  readonly type = OrdersActionTypes.FETCH_ORDER_MENU_ACTIONS;
  constructor(public order: Order) {}
}
export class FetchOrderActionsManagement {
  readonly type = OrdersActionTypes.FETCH_ORDER_MENU_ACTIONS_MANAGEMENT;
  constructor(public order: Order) {}
}
export class ClearOrderActionsManagement {
  readonly type = OrdersActionTypes.CLEAR_ORDER_MENU_ACTIONS_MANAGEMENT;
  constructor() {}
}
export class SetActionsForOrder {
  readonly type = OrdersActionTypes.SET_ORDER_MENU_ACTIONS;
  constructor(public orderActions: RmsOrderActionsResponse) {}
}
export class SetActionsForOrderManagement {
  readonly type = OrdersActionTypes.SET_ORDER_MENU_ACTIONS_MANAGEMENT;
  constructor(public orderActions: OrderActionODMItem[]) {}
}
export class SelectOrderToCancel {
  readonly type = OrdersActionTypes.SELECTED_ORDER_TO_CANCEL;
  constructor(public payload: Order) {}
}
export class ResetOrderToCancel {
  readonly type = OrdersActionTypes.RESET_ORDER_TO_CANCEL;
  constructor() {}
}
export class SubmitOrderToCancel {
  readonly type = OrdersActionTypes.SUBMIT_ORDER_TO_CANCEL;
  constructor(
    public order: Order,
    public cancelPayload: RmsOrderStatusChangeRequest,
  ) {}
}

export class SubmitOrderCancelODM {
  readonly type = OrdersActionTypes.SUBMIT_ORDER_CANCEL_ODM;
  constructor(
    public orderId: number,
    public cancelPayload: PatchOrderCancelRequest,
  ) {}
}

export class ValidateOrderToCancel {
  readonly type = OrdersActionTypes.VALIDATE_ORDER_TO_CANCEL;
  constructor(
    public order: Order,
    public requestToVerify: string,
  ) {}
}
export class ResponseOrderToCancel {
  readonly type = OrdersActionTypes.RESPONSE_ORDER_TO_CANCEL;
  constructor(public payload: any) {}
}
export class ResponseOrderToCancelODM {
  readonly type = OrdersActionTypes.RESPONSE_ORDER_TO_CANCEL_ODM;
  constructor(public payload: any) {}
}
export class ResponseValidateOrderToCancel {
  readonly type = OrdersActionTypes.RESPONSE_VALIDATE_ORDER_TO_CANCEL;
  constructor(public payload: any) {}
}
export class RequestCancelOptions {
  readonly type = OrdersActionTypes.FETCH_CANCEL_OPTIONS;
  constructor() {}
}
export class ResponseCancelOptions {
  readonly type = OrdersActionTypes.SET_CANCEL_OPTIONS;
  constructor(public payload: CancelReason[]) {}
}

export class ExpandOrder implements Action {
  readonly type = OrdersActionTypes.EXPAND_ORDER;

  constructor(public payload: Order) {}
}

export class SetBusinessLineCode implements Action {
  readonly type = OrdersActionTypes.BUSINESS_LINE_CODE;

  constructor(public payload: string) {}
}

export class ExpandOrderSuccessfully implements Action {
  readonly type = OrdersActionTypes.EXPAND_ORDER_SUCCESSFULLY;

  constructor(public payload: OrderExpand) {}
}

export class ExpandOdmOrderSuccessfully implements Action {
  readonly type = OrdersActionTypes.EXPAND_ODM_ORDER_SUCCESSFULLY;

  constructor(public payload: OdmExpand) {}
}

export class OrderByIdLoad implements Action {
  readonly type = OrdersActionTypes.LOAD_ORDERID;

  constructor(public payload: OrderDetailQueryParams) {}
}

export class OrderByIdLoadSuccess implements Action {
  readonly type = OrdersActionTypes.LOAD__ORDERID_SUCCESS;

  constructor(public payload: Order) {}
}

export class RequestOnlineCancelOptions {
  readonly type = OrdersActionTypes.FETCH_ONLINE_CANCEL_OPTIONS;
  constructor() {}
}

export class RequestCancellationReasons {
  readonly type = OrdersActionTypes.FETCH_CANCELLATION_REASONS;
  constructor(public orderId: number) {}
}

export class RequestModificationReasons {
  readonly type = OrdersActionTypes.FETCH_MODIFICATION_REASONS;
  constructor(public orderId: number) {}
}

export class SetActionExperience implements Action {
  readonly type = OrdersActionTypes.SET_ACTION_EXPERIENCE;
  constructor(public payload: ORDER_EXPERIENCES) {}
}

export class ReloadOrderList implements Action {
  readonly type = OrdersActionTypes.RELOAD_ORDER_LIST;

  constructor() {}
}

export class FetchOrderLoads implements Action {
  readonly type = OrdersActionTypes.FETCH_ORDER_LOADS;
  constructor(public payload: Order) {}
}

export class FetchOrderLoadsCompleted implements Action {
  readonly type = OrdersActionTypes.FETCH_ORDER_LOADS_COMPLETED;

  constructor(public payload: OrderLoads) {}
}

export class JobsiteExperienceLoad implements Action {
  readonly type = OrdersActionTypes.LOAD_JOBSITE_EXPERIENCE;
  constructor(public payload: { jobsiteCode: string; productTypeCode: string }) {}
}

export class JobsiteExperienceLoadSuccess implements Action {
  readonly type = OrdersActionTypes.LOAD_JOBSITE_EXPERIENCE_SUCCESS;
  constructor(public payload: boolean) {}
}

export class JobsiteExperienceLoadFail implements Action {
  readonly type = OrdersActionTypes.LOAD_JOBSITE_EXPERIENCE_FAIL;
  constructor() {}
}

export type OrdersActions =
  | OrdersLoad
  | OrdersLoadSuccess
  | OrdersLoadFail
  | OrdersSetLimit
  | OrdersSetCurrentPage
  | OrdersSetOrderBy
  | OrdersReset
  | OrdersSetDateTimeInterval
  | SelectOrderOnHold
  | RequestOrderOnHold
  | ResponseOrderOnHold
  | SelectResumeOrder
  | FetchActionsForOrder
  | FetchOrderActionsManagement
  | ClearOrderActionsManagement
  | SetActionsForOrder
  | SetActionsForOrder
  | SetActionsForOrderManagement
  | SelectOrderToCancel
  | ResetOrderToCancel
  | SubmitOrderToCancel
  | SubmitOrderCancelODM
  | ResponseOrderToCancel
  | ResponseOrderToCancelODM
  | ResponseCancelOptions
  | RequestCancelOptions
  | ValidateOrderToCancel
  | ResponseValidateOrderToCancel
  | ExpandOrder
  | ExpandOrderSuccessfully
  | ExpandOdmOrderSuccessfully
  | OrderByIdLoad
  | OrderByIdLoadSuccess
  | RequestOnlineCancelOptions
  | RequestCancellationReasons
  | SetActionExperience
  | ReloadOrderList
  | FetchOrderLoads
  | FetchOrderLoadsCompleted
  | SetBusinessLineCode
  | SubmitOrderToHoldOnline
  | ResponseOrderToHoldOnline
  | JobsiteExperienceLoad
  | JobsiteExperienceLoadSuccess
  | JobsiteExperienceLoadFail;
